// ============================================================
// supabase.js
// Supabase client — connects the app to your cloud database.
//
// WHAT SUPABASE DOES FOR US:
//   - Auth: user registration, login, sessions (replaces localStorage auth)
//   - Database: stores CSV data per user (syncs across devices)
//
// HOW SESSIONS WORK:
//   When a user logs in, Supabase stores a session token in
//   localStorage automatically. On page reload, it checks that
//   token and restores the session — the user stays logged in
//   until they explicitly log out.
//
// ENVIRONMENT:
//   The URL and anon key are loaded from environment variables.
//   Set them in a .env.local file (never commit this file):
//
//     REACT_APP_SUPABASE_URL=https://your-project.supabase.co
//     REACT_APP_SUPABASE_ANON_KEY=your-anon-key-here
//
//   The anon key only grants access through Row Level Security (RLS)
//   policies — each user can only read/write their own data.
// ============================================================

import { createClient } from '@supabase/supabase-js';

// Load Supabase credentials from environment variables.
// These are set in .env.local (for local dev) or in your
// hosting platform's environment settings (for production).
const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Safety check — crash early with a clear message if env vars are missing
if (!SUPABASE_URL || !SUPABASE_ANON) {
  throw new Error(
    'Missing Supabase environment variables. ' +
    'Create a .env.local file with REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY. ' +
    'See .env.local.example for the template.'
  );
}

// Create a single Supabase client instance shared across the app.
// This handles auth tokens, session refresh, and API requests.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
